module.exports = __webpack_public_path__ + "img/pic-audio.jpg";